export default {
  get name(): string {
    return 'ExpoAmplitude';
  },
};
